import { FieldValues, Path, PathValue, UseFormGetValues, UseFormSetValue } from 'react-hook-form'

/**
 * Откатывает черновик поповера фильтров — поля, выбранные без Apply Filters.
 *
 * Поля поповера живут в той же форме, что и тулбар, а форму целиком применяют и чипы, и поля
 * тулбара. Поэтому, когда поповер закрыли без Apply, поля формы возвращаем к применённому
 * фильтру из стора. Трогаем только разошедшиеся со стором: остальные и так применены.
 */
export const restoreAppliedValues = <F extends FieldValues>(
  getValues: UseFormGetValues<F>,
  setValue: UseFormSetValue<F>,
  applied: Partial<F>,
): void => {
  const values = getValues()

  for (const name of Object.keys(values) as Path<F>[]) {
    if (name in applied && applied[name] !== values[name]) {
      setValue(name, applied[name] as PathValue<F, Path<F>>)
    }
  }
}
